<template>
  <div style="height: 100%">
    <b-card style="border: none; margin-left: 2rem; margin-right: 2rem; height: 100%">
      <b-row style="height: 100%">
        <b-col class="mt-3" md="4" style="border-right: 1px grey solid">
          <b-row>
            <b-col md="4" class="my-auto">
              <span>Leistungsgruppe:</span>
            </b-col>
            <b-col>
              <b-input-group>
                <template #append>
                  <edit-icon @click="$refs.select_legr.showDialog(legrs)" title="" v-tooltip="'Anpassen'"
                             class="icon-1_5x" fillColor="#2463ea"
                             style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;"
                             :size="72"></edit-icon>
                </template>
                <b-form-input class="form-control text-black"
                              :style="selectedLegr.name !== null && selectedLegr.name !== '' ? '' : 'border-color: red'"
                              v-model="selectedLegr.name"
                              disabled
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="mt-3 mb-1">
            <b-col>
              <span>Verantwortlich / Abrechnend:</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <v-jstree ref="js_tree" :allow-transition="false"
                        :style="selectedKostMigr === null ? 'flex: 1 0; border: 1px solid red; border-radius: 0.25rem;' :'flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem;'"
                        class="my-tree" :data="kostMigrs"
                        @item-click="onItemClicked"
                        show-checkbox></v-jstree>
            </b-col>
          </b-row>

        </b-col>
        <b-col class="mt-3">
          <b-row style="margin-bottom: 12px; margin-left: 3px" >
            <span style="margin-top: auto; margin-bottom: auto">Wiederholungen:</span>
            <b-form-radio-group
                id="btn-radios-2"
                v-model="seriesType"
                :options="seriesTypes"
                button-variant="outline-primary"
                size="md"
                name="radio-btn-outline"
                buttons
                style="margin-left: 12px"
            ></b-form-radio-group>
          </b-row>
          <b-row v-if="seriesType === 'Y'">
            <b-col>
              <b-form-radio v-model="seriesSubTypes['Y']" value="D">Stichtag</b-form-radio>
              <b-row style="padding: 8px 12px">
                <b-col md="1" class="my-auto"><span class="label-horizontal label-fc-height">Am</span></b-col>
                <b-col md="3"><b-form-select v-model="day" :options="days" style="color: black"></b-form-select></b-col>
                <b-col md="3"><b-form-select v-model="month" :options="monthsSelect" style="color: black"></b-form-select></b-col>
              </b-row>
              <b-form-radio v-model="seriesSubTypes['Y']" value="WD">Wochentag</b-form-radio>
              <b-row style="padding: 8px 12px">
                <b-col md="1" class="my-auto"><span class="label-horizontal label-fc-height">Den</span></b-col>
                <b-col md="3"><b-form-select v-model="week" :options="weekSelect" style="color: black"></b-form-select></b-col>
                <b-col md="3"><b-form-select v-model="weekDay" :options="weekDaySelect" style="color: black"></b-form-select></b-col>
                <b-col md="1" class="my-auto"><span class="label-horizontal label-fc-height">im</span></b-col>
                <b-col md="3"><b-form-select v-model="month" :options="monthsSelect" style="color: black"></b-form-select></b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col md="1">
                  <div style="margin-top: 8px">Alle </div></b-col>
                <b-col md="2"><b-form-input v-model="year" style="" type="number"></b-form-input></b-col>
                <b-col md="4"><div style="margin-top: 8px"> Jahre ausführen.</div></b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-else-if="seriesType === 'M'">
            <b-col>
              <b-form-radio v-model="seriesSubTypes['M']" value="D">Stichtag</b-form-radio>
              <b-row style="padding: 8px 12px">
                <b-col md="1" class="my-auto"><span class="label-horizontal label-fc-height">Am</span></b-col>
                <b-col md="3"><b-form-select v-model="day" :options="days" style="color: black"></b-form-select></b-col>
              </b-row>
              <b-form-radio v-model="seriesSubTypes['M']" value="WD">Wochentag</b-form-radio>
              <b-row style="padding: 8px 12px">
                <b-col md="1" class="my-auto"><span class="label-horizontal label-fc-height">Den</span></b-col>
                <b-col md="3"><b-form-select v-model="week" :options="weekSelect" style="color: black"></b-form-select></b-col>
                <b-col md="3"><b-form-select v-model="weekDay" :options="weekDaySelect" style="color: black"></b-form-select></b-col>
              </b-row>
              <b-form-group label="In folgenden Monaten:" style="margin-top: 10px">
                <b-form-checkbox-group
                    v-model="selectedMonths"
                    :options="monthsSelectPlain"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col>
              <b-row style="padding: 8px 12px">
                <b-col md="1" class="my-auto"><span class="label-horizontal label-fc-height">Jede</span></b-col> <b-col md="2"><b-form-input v-model="num_weeks" style="" type="number"></b-form-input></b-col><b-col md="2"><span class="label-horizontal label-fc-height">Woche am</span></b-col>
                <b-col md="3"><b-form-select v-model="weekDay" :options="weekDaySelect" style="color: black"></b-form-select></b-col>
              </b-row>
              <b-form-group label="In folgenden Monaten:" style="margin-top: 10px">
                <b-form-checkbox-group
                    v-model="selectedMonths"
                    :options="monthsSelectPlain"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="height: 1px; background-color: rgb(189 189 189);" class="mt-2 mb-3" ></b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Erste Wiederholung ab:"
                  label-for="start-date"
              >
                <datetime
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    v-model="startDate"
                    input-class="form-control"
                    input-style="color: black;"
                    input-id="start-date"
                    :aria-placeholder="formateDateStart"
                    :phrases="datetimeConfig.phrases"
                    :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                    :min-datetime="minDate"></datetime>

              </b-form-group>
              <label for="close_automatic" v-if="hasDefaultPlanning">Fertigstellungsart:</label>
              <b-form-select :options="closeAutomaticSelects" id="close_automatic"
                             v-model="closeAutomatic"
                             class="mb-2 text-black" v-if="hasDefaultPlanning"></b-form-select>
            </b-col>
            <b-col>
              <b-form-group
                  label="Endet am:"
                  label-for="end-date"
              >
                <datetime
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    v-model="endDate"
                    input-class="form-control"
                    input-style="color: black;"
                    input-id="end-date"
                    :aria-placeholder="formateDateEnd"
                    :phrases="datetimeConfig.phrases"
                    :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                    :min-datetime="minDate"></datetime>
              </b-form-group>
              <label for="close_automatic" v-if="hasDefaultPlanning">Standartzuweisung:</label>
              <b-row v-if="hasDefaultPlanning">
                <b-col>
                  <b-form-input class="form-control" style="color: black"
                                v-model="defaultAllocationText"
                                disabled @click="$refs.select_default_planning_dialog.showDialog(defaultAllocation)"></b-form-input>
                </b-col>
                <b-col md="2" style="padding-left: 0px; padding-top: 5px">
                  <edit-icon title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style=" cursor: pointer; color: #016d03; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$refs.select_default_planning_dialog.showDialog(defaultAllocation)"></edit-icon>
                </b-col>
              </b-row>
            </b-col>
            <select-default-planning-dialog ref="select_default_planning_dialog" @default-selected="onDefaultSelected" />
          </b-row>
          <b-row style="height: 1px; background-color: rgb(189 189 189);" class="mt-2 mb-3"></b-row>
          <b-row>
            <b-col>
              <div style="margin-top: 8px">Sende an mobile Geräte </div></b-col>
            <b-col md="2"><b-form-input v-model="sendMobileInterval" style="" type="number"></b-form-input></b-col>
            <b-col md="3"><b-form-select v-model="sendMobileIntervalType" :options="sendMobileIntervalTypeSelects" style="color: black"></b-form-select></b-col>
            <b-col md="4"><div style="margin-top: 8px"> vor Fälligkeit der Aufgabe.</div></b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <select-legr-dialog ref="select_legr" @legr-selected="onLegrChanged"></select-legr-dialog>

  </div>
</template>

<script>
import {arrayContains, Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
import EditIcon from 'vue-material-design-icons/PencilCircle.vue';
import PencilPlusIcon from "vue-material-design-icons/PencilPlus.vue";
import PlusIcon from "vue-material-design-icons/PlusCircle.vue";
import MinusIcon from "vue-material-design-icons/MinusCircle.vue";
import VJstree from "vue-jstree";
import SelectLegrDialog from "../../aufgaben_verwaltung/SelectLegrDialog.vue"
import {v4, v4 as uuidv4} from 'uuid';
import {DateTime as LuxonDateTime} from 'luxon'
import {parseTimestamp} from "@/shared/dates";
import SelectDefaultPlanningDialog from "@/views/aufgaben_verwaltung/SelectDefaultPlanningDialog.vue";


export default {
  name: "task_step_plan_task",
  props: ['currentStep', 'isVisible'],
  components: {
    EditIcon,
    PencilPlusIcon,
    PlusIcon,
    MinusIcon,
    VJstree,
    SelectLegrDialog,
    SelectDefaultPlanningDialog
  },
  mounted() {
    this.$emit('can-continue', {value: false});
    this.legrs = this.currentStep.payload.legrs;
    this.kostMigrs = this.computeKostMigrs(this.currentStep.payload.bhStructure);
    this.users = this.currentStep.payload.bhStructure;
    this.dueDate = this.currentStep.payload.dueDate;
    this.taskMemo = this.currentStep.payload.taskMemo;
    this.taskSubject = this.currentStep.payload.taskSubject;
    this.computeMitas(this.users);
    if (this.currentStep.payload.bhStructure) {
      this.hasDefaultPlanning = true;
      this.$nextTick(() => {
        let data = JSON.parse(JSON.stringify(this.currentStep.payload.bhStructure));
        this.computeMitas(data);
        this.$refs.select_default_planning_dialog.init(data);
      })
    } else {
      this.hasDefaultPlanning = false;
    }
    let modules = sessionStorage.getItem("suite_modules");
    if (modules !== null && modules !== "") {
      modules = JSON.parse(modules);
      if (arrayContains(modules, 24)) {
        this.hasTaskSeries = true;
      }
    }
  },
  data() {
    return {
      loader: undefined,
      legrs: [],
      kostMigrs: [],
      users: [],
      acceptTaskOptions: [{text: "als Aufgabe", value: 'Aufgabe'}, {text: "als Einzelauftrag", value: 'Auftrag'}], //, {text: "Nein", value: ''}
      acceptTask: 'Aufgabe',
      selectedLegr: {name: ""},
      selectedKostMigr: null,
      //planningFields: [{key: "name", label: 'Name'}, {key: "till", label: "Ziel", formatter: 'formateDueDate'}, {key: "message",label: "Aufagbentext"}],
      planningFields: [{key: "name", label: 'Name'}, {
        key: "dueDate",
        label: "Ziel",
        formatter: 'formateDueDate'
      }, {key: "memo", label: "Aufgabentext"}],
      selectedPlannings: [],
      dueDate: null,
      taskMemo: "",
      taskSubject: "",
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      currentPlanning: null,
      close_automatic: false,
      close_automatic_select: [{text: "Manuelle Fertigstellung", value: false}, {
        text: "Automatische Fertigstellung",
        value: true
      }],
      bhStructure: [],
      task_series: null,
      task_series_enabled: false,
      hasTaskSeries: false,

      seriesType: "Y",
      seriesTypes: [{text: "Jährlich", value: "Y"},{text: "Monatlich", value:"M"}, {text: "Wöchentlich", value: "W"}],
      seriesSubTypes: {
        "Y": "D",
        "M": "D",
        "W": ""
      },
      day: -1,
      days: [{text: "Bitte wählen", value: -1},1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      weekDay: -1,
      week: -1,
      num_weeks: 1,
      month: -1,
      selectedMonths: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      weekSelect: [
        {text: "Bitte wählen", value: -1},
        {text: "ersten", value: 1},
        {text: "zweiten", value: 2},
        {text: "dritten", value: 3},
        {text: "vierten", value: 4},
      ],
      weekDaySelect: [
        {text: "Bitte wählen", value: -1},
        {text: "Montag", value: 1},
        {text: "Dienstag", value: 2},
        {text: "Mittwoch", value: 3},
        {text: "Donnerstag", value: 4},
        {text: "Freitag", value: 5},
        {text: "Samstag", value: 6},
        {text: "Sonntag", value: 0},
      ],
      monthsSelect: [
        {text: "Bitte wählen", value: -1},
        {text: "Januar", value: 1},
        {text: "Februar", value: 2},
        {text: "März", value: 3},
        {text: "April", value: 4},
        {text: "Mai", value: 5},
        {text: "Juni", value: 6},
        {text: "Juli", value: 7},
        {text: "August", value: 8},
        {text: "September", value: 9},
        {text: "Oktober", value: 10},
        {text: "November", value: 11},
        {text: "Dezember", value:12},
      ],
      monthsSelectPlain: [
        {text: "Januar", value: 1},
        {text: "Februar", value: 2},
        {text: "März", value: 3},
        {text: "April", value: 4},
        {text: "Mai", value: 5},
        {text: "Juni", value: 6},
        {text: "Juli", value: 7},
        {text: "August", value: 8},
        {text: "September", value: 9},
        {text: "Oktober", value: 10},
        {text: "November", value: 11},
        {text: "Dezember", value:12},
      ],
      year: 1,
      defaultAllocation: "",
      defaultAllocationText: "",
      closeAutomatic: false,
      closeAutomaticSelects: [{text: "Manuelle Fertigstellung", value: false}, {text: "Automatische Fertigstellung", value: true}],
      startDate: LuxonDateTime.local(new Date().getFullYear()+1, 1, 1, 15).toISO(),
      endDate: null,
      endAfterCount: -1,


      // send mobile interval
      sendMobileInterval: 1,
      sendMobileIntervalType: "W",
      sendMobileIntervalTypeSelects: [{text: "Tag(e)", value: "D"},{text: "Woche(n)", value:"W"}],


      show: false,
      error: false,
      hasDefaultPlanning: true,
      seriesChange: false,
    }
  },
  computed: {
    taskSeriesTitle() {
      if (!this.task_series) {
        return this.task_series_enabled ? "Bitte definieren ->" : "Keine Wiederholung"
      } else {
        switch (this.task_series.series_type) {
          case "Y":
            return "Jährliche Wiederholung";
          case "M":
            return "Monatliche Wiederholung";
          case "W":
            return "Wöchentliche Wiederholung";
        }
      }
      return "";
    },
    minDate() {
      let d =  new Date().toISOString();
      let start = new Date(d.replace('Z', ''));
      return start.toISOString();
    },
  },
  watch: {

    seriesType(n, o) {
      this.seriesChange = true;
      let d = new Date().toISOString();
      let start = new Date(d.replace('Z', ''));
      if (n === 'Y') {
        this.startDate = LuxonDateTime.local(start.getFullYear() + 1, 1, 1, 15).toISO();
        this.year = 1;
        this.week = -1;
      } else if (n === 'M') {
        this.startDate = LuxonDateTime.local(start.getFullYear(), start.getMonth()+2, 1, 15).toISO();
        this.week = -1;
      } else {
        this.week = 1;
        start.setDate(start.getDate()+7)
        this.startDate = start.toISOString();
      }
      this.day = -1;
      this.weekDay = -1;
      this.month = -1;
      this.selectedMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      this.seriesChange = false;
      this.$emit('can-continue', {value: this.canContinue()});
    },
    day(n, o) {
      this.calculateFirstSeriesDate()
      this.$emit('can-continue', {value: this.canContinue()});
    },
    week(n, o) {
      this.calculateFirstSeriesDate()
      this.$emit('can-continue', {value: this.canContinue()});
    },
    year(n, o) {
      this.calculateFirstSeriesDate()
      this.$emit('can-continue', {value: this.canContinue()});
    },
    month(n, o) {
      this.calculateFirstSeriesDate()
      this.$emit('can-continue', {value: this.canContinue()});
    },
    weekDay(n, o) {
      this.calculateFirstSeriesDate()
      this.$emit('can-continue', {value: this.canContinue()});
    },
    selectedMonths(n, o) {
      this.calculateFirstSeriesDate()
      this.$emit('can-continue', {value: this.canContinue()});
    },

    selectedLegr(n, o) {
      this.$emit('can-continue', {value: this.canContinue()});
    },
    selectedKostMigr(n, o) {
      this.$emit('can-continue', {value: this.canContinue()});
    },
  },
  methods: {
    canContinue() {
      if (this.selectedLegr.name === "" || !this.selectedKostMigr || !this.startDate) {
        return false;
      }
      if (parseInt(this.sendMobileInterval) < 0) {
        return false;
      }
      if (this.seriesType === 'Y') {
        if (this.year < 1) {
          return false;
        }
        if (this.seriesSubTypes['Y'] === 'D') {
          return this.day !== -1 && this.month !== -1;
        } else {
          return this.week !== -1 && this.weekDay !== -1 && this.month !== -1;
        }
      } else if (this.seriesType === 'M') {
        if (this.selectedMonths.length === 0) {
          return false;
        }
        if (this.seriesSubTypes['M'] === 'D') {
          return this.day !== -1;
        } else {
          return this.week !== -1 && this.weekDay !== -1;
        }
      } else {
        if (this.selectedMonths.length === 0) {
          return false;
        }
        return this.weekDay !== -1;
      }
    },
    calculateFirstSeriesDate() {
      let d = this.taskDate;
      if (!d) {
        d = new Date().toISOString();
      }
      let start = new Date(d.replace('Z', ''));
      let date = null;
      if (this.seriesType === 'Y') {
        date = this.calculateNextYearlyDate(start);
      } else if (this.seriesType === 'M') {
        date = this.calculateNextMonthlyDate(start);
      } else if (this.seriesType === 'W') {
        date = this.calculateNextWeeklyDate(start);
      }
      if (date !== null) {
        this.startDate = LuxonDateTime.local(date.getFullYear(), date.getMonth()+1, date.getDate(), 15).toISO();
      }
    },
    calculateNextYearlyDate(start) {
      let nextDate = null;
      if (this.day !== -1 && this.month !== -1 && this.seriesSubTypes['Y'] === 'D') {
        nextDate = new Date(start.getFullYear(), this.month - 1, this.day, 12);
      } else if (this.month !== -1 && this.week !== -1 && this.weekDay !== -1) {
        nextDate = new Date(start.getFullYear(), this.month - 1, 1, 12);
        nextDate.setDate(nextDate.getDate() + (this.weekDay - nextDate.getDay() + 7) % 7 + 7 * (this.week - 1));
      } else {
        return null;
      }
      start.setHours(0, 1)
      if (nextDate < start) {
        nextDate.setFullYear(nextDate.getFullYear() + 1);
      }
      return nextDate;
    },
    calculateNextMonthlyDate(start) {
      let months = [];
      for (let i = 0; i < this.selectedMonths.length; i++) {
        months.push(parseInt(this.selectedMonths[i])-1);
      }
      // order the months
      months.sort((a, b) => a - b);
      if (months.length === 0) {
        return null;
      }
      let nextDate = null;
      let yearAddition = 0;
      while (true) {
        for (let i = 0; i < months.length; i++) {
          if (this.day !== -1 && this.seriesSubTypes['M'] === 'D') {
            nextDate = new Date(
                start.getFullYear() + yearAddition,
                months[i],
                this.getNormalizedDay(start.getFullYear() + yearAddition, months[i], this.day),
                12);
          } else if (this.weekDay !== -1 && this.week !== -1) {
            nextDate = new Date(
                start.getFullYear() + yearAddition,
                months[i],
                1,
                12);
            nextDate.setDate(nextDate.getDate() + (this.weekDay - nextDate.getDay() + 7) % 7 + 7 * (this.week - 1));
          } else {
            return null;
          }
          if (nextDate >= start) {
            return nextDate;
          }
        }
        yearAddition++;
        if (yearAddition > 4) {
          return null;
        }
      }
    },
    getNormalizedDay(year, month, day) {
      let day2 = 32 - new Date(year, month, 32).getDate();
      if (day < day2) {
        return day;
      }
      return day2;
    },
    calculateNextWeeklyDate(start) {
      let months = [];
      for (let i = 0; i < this.selectedMonths.length; i++) {
        months.push(parseInt(this.selectedMonths[i])-1);
      }
      // order the months
      months.sort((a, b) => a - b);
      if (months.length === 0) {
        return null;
      }
      if (this.weekDay !== -1) {
        start.setDate(start.getDate() + (this.weekDay - start.getDay() + 7) % 7);
        while (!this.isInMonths(start, months)) {
          start.setDate(start.getDate() + 7);
        }
        return start;
      }
      return null;
    },
    isInMonths(date, months) {
      let month = date.getMonth();
      return months.includes(month);
    },
    onDefaultSelected(def) {
      this.defaultAllocationText = def.map((list) => list.name).join(", ")
      this.defaultAllocation = def.map((list) => list.id).join(",")
    },
    formateDateStart() {
      if (this.startDate === null) {
        return ""
      }
      let event = new Date(this.startDate.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateDateEnd() {
      if (this.endDate === null) {
        return "kein Ende"
      }
      let event = new Date(this.endDate.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },

    setActive: function (payload) {
      if (this.$emit) {
        if (this.canContinue()) {
          this.$emit('can-continue', {value: true});
          return;
        }
        this.$emit('can-continue', {value: false});
      }
    },
    getReturnData: function () {
      let task_series = {
        series_type: this.seriesType,
        default_allocation: this.defaultAllocation,
        close_automatic: this.closeAutomatic,
        start_date: this.startDate,
        end_date: this.endDate === "" ? null : this.endDate,
        day: this.seriesSubTypes[this.seriesType] === "D" ? this.day : -1,
        weekday: this.weekDay,
        week: this.week,
        num_weeks: parseInt(this.num_weeks),
        month: this.month,
        year: parseInt(this.year),
        months: this.selectedMonths.join(","),
        send_mobile_interval: parseInt(this.sendMobileInterval),
        send_mobile_interval_type: this.sendMobileIntervalType,
      };
      let todos = [];
      if (this.defaultAllocation !== "") {
        let def = this.defaultAllocation.split(",");
        for (let i = 0; i < def.length; i++) {
          todos.push({id: def[i], memo: this.taskMemo, dueDate: this.startDate});
        }
      }
      return {
        selected_legr: this.selectedLegr,
        selected_kost_migr: this.selectedKostMigr,
        dueDate: this.startDate,
        todos: todos,
        close_automatic: this.closeAutomatic,
        task_series: task_series,
      };
    },
    onLegrChanged(data) {
      this.selectedLegr = data.selected_legr;
    },
    onItemClicked(node, item, e) {
      this.selectedKostMigr = item;
    },
    computeKostMigrs(data) {
      data.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
  }
}
</script>

<style scoped>

</style>
